export const SELECT_EXTERIOR_COLOR_AT_DJUBLI_CHECK = 'SELECT_EXTERIOR_COLOR_AT_DJUBLI_CHECK'
export const RESET_EXTERIOR_COLOR_AT_DJUBLI_CHECK = 'RESET_EXTERIOR_COLOR_AT_DJUBLI_CHECK'

export const SELECT_CITY_AT_DJUBLI_CHECK = 'SELECT_CITY_AT_DJUBLI_CHECK'
export const RESET_CITY_AT_DJUBLI_CHECK = 'RESET_CITY_AT_DJUBLI_CHECK'